import { array, option, record } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import * as iots from 'io-ts';
export function sanitizeError(error) {
    const cause = pipe(error.cause, sanitizeExtra, option.toUndefined);
    return {
        name: error.name,
        message: error.message,
        ...(error.stack != null ? { stack: error.stack } : {}),
        ...(cause != null ? { cause } : {}),
    };
}
const UnknownRecord = iots.record(iots.string, iots.unknown);
export const sanitizeExtra = (extra) => {
    if (typeof extra === 'number')
        return option.some(extra);
    if (typeof extra === 'string')
        return option.some(extra);
    if (typeof extra === 'boolean')
        return option.some(extra);
    if (extra instanceof Date)
        return option.some(extra);
    if (extra == null)
        return option.some(extra);
    if (Array.isArray(extra))
        return pipe(extra, array.filterMap(sanitizeExtra), option.some);
    if (extra instanceof Error)
        return option.some(sanitizeError(extra));
    if (UnknownRecord.is(extra)) {
        return pipe(extra, record.filterMap(sanitizeExtra), option.some);
    }
    return option.none;
};
//# sourceMappingURL=sanitize.js.map